import { render, staticRenderFns } from "./ErrorsPage.vue?vue&type=template&id=7948af56&scoped=true"
import script from "./ErrorsPage.vue?vue&type=script&lang=js"
export * from "./ErrorsPage.vue?vue&type=script&lang=js"
import style0 from "./ErrorsPage.vue?vue&type=style&index=0&id=7948af56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7948af56",
  null
  
)

export default component.exports